<template>
	<div class="b-cont">
		<div>
			<sections 
				class="b-cells" 
				title="开庭信息" 
				m-color="#46CDCF" 
				content-height="auto"
				:show-save="true"
				type="save_court"
				@save="handleAction">
				<div v-empty="list.length <= 0" style="min-height: 500px;">
					<flexbox 
						:gutter="0" 
						wrap="wrap" 
						style="padding: 10px 8px;margin:25px 0;"
						v-if="list.length > 0"
						v-for="(item,index) in list"
						:key="index">
						<table
							class="table table-hover"
							v-loading="loading">
							<tbody>
								<tr>
									<td class="tdleft" width="15%">开庭律师</td>
									<td width="35%">
										<template v-for="(i,k) in item.user_courtlawyer_user_id">
											{{i.username}}{{k > 0 ? ',' :''}}
										</template>
									</td>
									<td class="tdleft" width="15%">承办助理</td>
									<td width="35%">
										<template v-for="(i,k) in item.user_courtassistant_user_id">
											{{i.username}}{{k > 0 ? ',' :''}}
										</template>
									</td>
								</tr>
								<tr>
									<td class="tdleft" width="15%">客户</td>
									<td width="35%">
										<el-link type="primary" @click="showSetmeal(item.customer)">
											{{item.customer.name}}
										</el-link>
									</td>
									<td class="tdleft" width="15%">开庭时间</td>
									<td width="35%">{{item.court_date}}</td>
								</tr>
								<tr>
									<td class="tdleft" width="15%">开庭城市</td>
									<td  width="35%">{{item.court_city}}</td>
									<td class="tdleft" width="15%">开庭法院</td>
									<td  width="35%">{{item.court_name}}</td>
								</tr>
								<tr>
									<td class="tdleft" width="15%">应到处所</td>
									<td width="35%">{{item.count_place}}</td>
									<td class="tdleft" width="15%">服务内容</td>
									<td width="35%">{{item.service_content_str}}</td>
								</tr>
								<tr>
									<td class="tdleft" width="15%">开庭次数</td>
									<td width="35%">{{item.court_count}}</td>
									<td class="tdleft" width="15%">开庭方式</td>
									<td width="35%">{{item.service_mode}}</td>
								</tr>
								<!-- <tr>
									<td class="tdleft" width="15%">补贴金额</td>
									<td colspan="3">{{item.pay_price}}</td>
								</tr> -->
								<tr>
									<td class="tdleft" width="15%">附件</td>
									<td colspan="3">
										<span
											v-if="item.file_id.length > 0"
											v-for="(v,k) in item.file_id"
											:key="k">
											<a
												v-if="v.file_type == 'image'"
												@click="previewImg(item.file_id, k)"
												href="javascript:void(0);"
												style="display: block;">{{v.name}}</a>
											<a
												v-else
												:href="v.file_path"
												target="_blank"
												style="display: block;">{{v.name}}</a>
										</span>
									</td>
								</tr>
								<tr>
									<td class="tdleft" width="15%">备注</td>
									<td colspan="3">{{item.count_description}}</td>
								</tr>
								<tr>
									<td class="tdleft" width="15%">创建人</td>
									<td width="35%">{{item.create_user_id[0].username}}</td>
									<td class="tdleft" width="15%">创建时间</td>
									<td width="35%">{{item.create_time}}</td>
								</tr>
								<tr v-if="item.cl_reason">
									<td class="tdleft" width="15%">取消原因</td>
									<td colspan="3">{{item.cl_reason}}</td>
								</tr>
								<tr v-if="item.cancel_time">
									<td class="tdleft" width="15%">取消人</td>
									<td width="35%">{{item.cancel_user_id[0].username}}</td>
									<td class="tdleft" width="15%">取消时间</td>
									<td width="35%">{{item.cancel_time | filterTimestampToFormatTime("YYYY-MM-DD HH:mm")}}</td>
								</tr>
							</tbody>
						</table>
						<div style="margin-top: 10px;width: 100%;display: flex;justify-content: flex-end;align-items: flex-end;">
							<el-button
								type="primary" 
								plain 
								style="color:#fff"
								v-if="allAuth.lawcase.confirm_court && item.is_confirm == 0"
								@click="handleAction({'type':'confirm_court','data':item})">确认已开庭</el-button>
							<el-button
								type="info" 
								plain 
								v-if="allAuth.lawcase.cancel_court  && item.cancel_time == 0"
								@click="handleAction({'type':'cancel_court','data':item})">取消</el-button>
							<el-button 
								type="warning" 
								plain 
								v-if="allAuth.lawcase.update_court"
								@click="handleAction({'type':'update_court','data':item})">修改</el-button>
							<el-button 
								type="danger" 
								plain 
								v-if="allAuth.lawcase.del_court"
								@click="handleAction({'type':'del_court','data':item})">删除</el-button>
						</div>
					</flexbox>
				</div>
			</sections>
		</div>
		<!-- dialog弹窗 -->
		<dialog-form
			:dialog-visible="dialogForm"
			:title="title"
			ref="crmform"  
			:crm-type="crmType"
			:action="action"
			:form-data="formData"
			@close = "closeDialog"
			@save-dialog="saveDialog">
		</dialog-form>
	</div>
</template>

<script>
	import Sections from '../../customer/Sections'
	import moment from 'moment'
	import { mapGetters } from 'vuex'
	import {DialogForm} from '@/components/FromData'
	// API
	import { filedGetField } from '@/api/setting/setting'
	import { 
		crmLawcaseCourtList,
		crmLawcaseCourtSave,
		crmLawcaseCourtUpdate,
		crmLawcaseCourtDel,
		crmLawcaseCourtConfirm,
		crmLawcaseCourtCancel
	} from '@/api/lawcase/lawcase'
	
	
	export default {
		/** 客户管理 的 基本信息*/
		name: 'CRMBaseInfo',
		components: {
			Sections,
			DialogForm
		},
		filters: {
			
		},
		mixins: [],
		props: {
			/** 模块ID */
			id: [String, Number],
			customer_id: [String, Number],
			/** 没有值就是全部类型 有值就是当个类型 */
			crmType: {
				type: String,
				default: ''
			},
			detail: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				list: [],
				loading:false,
				
				
				// dialog弹窗
				dialogForm:false,
				title:"",
				dialogType:"",
				action:{ type: '',relevant:'' ,actiontype:''},
				formData:{},
			}
		},
		computed: {
			...mapGetters(['allAuth']),
		},
		watch: {
			id: function(val) {
				this.getBaseInfo()
			}
		},
		mounted() {
			this.$bus.$on("refresh-detail",()=>{
			   return this.getBaseInfo()
			})
			this.getBaseInfo()
		},
		activated: function() {},
		deactivated: function() {},
		methods: {
			
			// 获取基础信息
			getBaseInfo() {
				this.loading = true
				crmLawcaseCourtList({
						lawcase_id: this.id
					})
					.then(res => {
						// console.log(res.data);
						this.list = res.data
						this.loading = false
					})
					.catch(() => {
						this.loading = false
					})
			},
			
			// 添加信息
			handleAction(item){
				switch (item.type){
					case "save_court":
						this.title = "新增信息"
						this.dialogForm = true
						this.action = { type: 'save',relevant:'court',actiontype:28 }
						break;
						
					case "update_court":
						this.title = "修改信息"
						this.formData = JSON.parse(JSON.stringify(item.data))
						this.dialogForm = true
						this.action = { type: 'update',relevant:'court',actiontype:28 }
						break;
						
					case "del_court":
						this.delInfo({"type":item.type,"data":item.data})
						break;
						
					case "confirm_court":
						this.delInfo({"type":item.type,"data":item.data})
						break;
						
					case "cancel_court":
						this.title = "取消开庭"
						this.dialogForm = true
						this.formData = JSON.parse(JSON.stringify(item.data))
						this.action = { type: 'update',relevant:'cancel_court',actiontype:29 }
						break;
				}
			},
			
			// 弹窗操作
			closeDialog(){
				this.title = ""
				this.dialogForm = false
				this.formData = {}
			},
			saveDialog(item){
				let data = item.data
				data["lawcase_id"] = this.id
				data["customer_id"] = this.detail.customer_id
				let request
				if(item.type == "save_court"){
					request = crmLawcaseCourtSave
				}else if(item.type == "update_court"){
					request = crmLawcaseCourtUpdate
				}else if(item.type == "update_cancel_court"){
					request = crmLawcaseCourtCancel
				}
				
				request(data)
					.then(res => {
						this.$message.success(res.data)
						
						if(item.type == "save_court"){
							this.$store.commit('incrementByLawcase','court')
						}
						this.closeDialog()
						this.getBaseInfo()
					})
			},
			delInfo(item){
				let request
				if(item.type == "del_court"){
					request = crmLawcaseCourtDel
				}else if(item.type == "confirm_court"){
					request = crmLawcaseCourtConfirm
				}
				this.$confirm('确定进行此操作吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					request({
						id: item.data.id
					})
					.then(res => {
						this.$message.success(res.data)
						if(item.type == "del_court"){
							this.$store.commit('descrementByLawcase','court')
						}
						this.getBaseInfo()
					})
					.catch(() => {})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					})
				})
			},
			
			// 预览图片
			previewImg(list, index) {
				this.$bus.emit('preview-image-bus', {
					index: index,
					data: list.map(function(item, index, array) {
						item.url = item.file_path
						return item
					})
				})
			},
			
			// 显示
			showSetmeal(item){
				this.$router.push({
					path:"/customer/read/basicinfo/"+item.id
				}) 
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.b-cont {
		position: relative;
		padding: 0 50px 20px 20px;
	}

	.b-cells {
		margin-top: 25px;
	}

	.b-cell {
		padding: 0 10px;

		.b-cell-b {
			width: auto;
			padding: 8px;

			.b-cell-name {
				width: 100px;
				margin-right: 10px;
				font-size: 13px;
				flex-shrink: 0;
				color: #777;
			}

			.b-cell-value {
				font-size: 13px;
				color: #333;
				white-space: pre-wrap;
				word-wrap: break-word;
			}

			.b-cell-foot {
				flex-shrink: 0;
				display: block;
				width: 15px;
				height: 15px;
				margin-left: 8px;
			}
		}
	}

	.f-item {
		padding: 3px 0;
		height: 25px;

		.f-img {
			position: block;
			width: 15px;
			height: 15px;
			padding: 0 1px;
			margin-right: 8px;
		}

		.f-name {
			color: #666;
			font-size: 12px;
			margin-right: 10px;
		}
	}
	.table{
		width: 100%;
		font-size: 12px !important;
	}
	
	.table td {
		vertical-align: middle;
		padding: 15px 10px;
		line-height: 20px;
		border: 1px solid #EEEEEE;
		white-space: pre-wrap;
		word-break: break-all;
	}
	.table td.tdleft {
		text-align: center;
		background: #f6faff;
	}
	.table tr:hover {
		background: #f6faff;
	}
	
</style>
